import React, { useState } from 'react'

interface NPSQuestionProps {
  body: string
  required: boolean
  readOnly?: boolean
  onChange?: (value: string) => void
}

const NPSQuestion: React.FC<NPSQuestionProps> = ({ body, required, readOnly = false, onChange }) => {
  const [selectedValue, setSelectedValue] = useState<string>('')

  const handleChange = (value: string) => {
    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <div>
      <p className="font-bold text-gray-800 mb-4">{body}</p>

      {/* Selector para móvil */}
      <div className="md:hidden">
        <label htmlFor="nps-select" className="font-semibold block mb-2">
          Selecciona un número
        </label>
        <select
          id="nps-select"
          value={selectedValue}
          onChange={e => handleChange(e.target.value)}
          className="w-full p-3 border border-gray-800 rounded-lg bg-white"
        >
          <option value="" disabled>
            Selecciona...
          </option>
          {Array.from({ length: 11 }, (_, i) => (
            <option key={i} value={i}>
              {i}
            </option>
          ))}
        </select>
      </div>

      {/* Botones para desktop accesibles */}
      <div className="nps-scale hidden md:block">
        <fieldset
          className="grid grid-cols-11 gap-0 rounded-lg overflow-hidden p-2"
          role="radiogroup"
          aria-label="Escala de satisfacción del 0 al 10"
        >
          <legend className="sr-only">{body}</legend>
          {Array.from({ length: 11 }, (_, i) => (
            <label
              key={i}
              className={`nps-radio flex items-center justify-center cursor-pointer py-4 relative rounded-full`}
              style={{
                width: '3.5rem',
                height: '3.5rem'
              }}
            >
              <input
                type="radio"
                name="nps"
                value={i}
                checked={selectedValue === i.toString()}
                onChange={() => handleChange(i.toString())}
                disabled={readOnly}
                className="appearance-none w-full h-full rounded-full border-2 border-gray-400 cursor-pointer"
                style={{
                  background: selectedValue === i.toString() ? '#2563eb' : '#fff',
                  borderColor: selectedValue === i.toString() ? '#2563eb' : '#ccc',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  zIndex: 1,
                }}
              />
              <span
                className="text-lg font-bold pointer-events-none"
                style={{
                  color: selectedValue === i.toString() ? '#fff' : '#333',
                  position: 'relative',
                  zIndex: 2,
                  textAlign: 'center',
                }}
              >
                {i}
              </span>
            </label>
          ))}
        </fieldset>
        {/* Labels below */}
        <div className="flex justify-between mt-2 px-1">
          <span className="text-sm text-gray-600">Nada probable</span>
          <span className="text-sm text-gray-600">Muy probable</span>
        </div>
      </div>
    </div>
  )
}

export default NPSQuestion
